let initialized = false
let deferredInstallPrompt = null

const promptListeners = new Set()
const installedListeners = new Set()

function notifyPromptListeners() {
  promptListeners.forEach(listener => listener(deferredInstallPrompt))
}

function notifyInstalledListeners() {
  installedListeners.forEach(listener => listener())
}

export function initPwaInstallPrompt() {
  if (initialized || typeof window === 'undefined') {
    return
  }

  initialized = true
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault()
    deferredInstallPrompt = event
    notifyPromptListeners()
  })
  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null
    notifyPromptListeners()
    notifyInstalledListeners()
  })
}

export function getPwaInstallPrompt() {
  initPwaInstallPrompt()
  return deferredInstallPrompt
}

export function consumePwaInstallPrompt() {
  initPwaInstallPrompt()
  const promptEvent = deferredInstallPrompt
  deferredInstallPrompt = null
  notifyPromptListeners()
  return promptEvent
}

export function subscribePwaInstallPrompt(listener) {
  initPwaInstallPrompt()
  promptListeners.add(listener)
  listener(deferredInstallPrompt)
  return () => {
    promptListeners.delete(listener)
  }
}

export function subscribePwaInstalled(listener) {
  initPwaInstallPrompt()
  installedListeners.add(listener)
  return () => {
    installedListeners.delete(listener)
  }
}

export function isStandaloneDisplayMode() {
  if (typeof window === 'undefined') {
    return false
  }
  return Boolean(window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone)
}

export async function getInstalledRelatedPwaApps() {
  initPwaInstallPrompt()
  if (typeof navigator === 'undefined' || typeof navigator.getInstalledRelatedApps !== 'function') {
    return []
  }

  try {
    const relatedApps = await navigator.getInstalledRelatedApps()
    return Array.isArray(relatedApps)
        ? relatedApps.filter(app => app?.platform === 'webapp')
        : []
  } catch (error) {
    console.warn('getInstalledRelatedApps failed', error)
    return []
  }
}

export async function isPwaInstalled() {
  if (isStandaloneDisplayMode()) {
    return true
  }
  return (await getInstalledRelatedPwaApps()).length > 0
}
